import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    { src: 'https://i.ibb.co/xKn2jMcH/Products-1.jpg', alt: 'Classic Zalabya' },
    { src: 'https://i.ibb.co/77JYx8p/Products-2.jpg', alt: 'Dubai Chocolate' },
    { src: 'https://i.ibb.co/VcnsdwQL/Products-3.jpg', alt: 'Strawberry Cup' },
    { src: 'https://i.ibb.co/nqZWLtqS/Products-4.jpg', alt: 'Nutella Zalabya' },
    { src: 'https://i.ibb.co/Q39nJWP7/Products-5.jpg', alt: 'Pistachio Delight' },
    { src: 'https://i.ibb.co/hFFH2zny/Products-6.jpg', alt: 'Mixed Flavors' },
    { src: 'https://i.ibb.co/fzRxxrBn/Products-7.jpg', alt: 'Chocolate Drizzle' },
    { src: 'https://i.ibb.co/Vp9zZCQ1/Products-8.jpg', alt: 'Caramel Special' },
    { src: 'https://i.ibb.co/tPwVD7JV/Products-9.jpg', alt: 'Fresh Batch' },
    { src: 'https://i.ibb.co/WpnNPF0Z/Products-10.jpg', alt: 'Golden Brown' },
    { src: 'https://i.ibb.co/Q4Z6tKp/Products-11.jpg', alt: 'Signature Style' },
    { src: 'https://i.ibb.co/FGcmgR0/Products-12.jpg', alt: 'Premium Toppings' },
    { src: 'https://i.ibb.co/6RdZGnDb/Products-14.jpg', alt: 'Artisan Creation' },
    { src: 'https://i.ibb.co/CsSBFFZj/Products-15.jpg', alt: 'Sweet Perfection' },
    { src: 'https://i.ibb.co/Xrc7PmWZ/Products-16.jpg', alt: 'Delicious Variety' },
    { src: 'https://i.ibb.co/RGC4wjFd/Products-17.jpg', alt: 'Traditional Style' },
    { src: 'https://i.ibb.co/4R1kJPQh/Products-18.jpg', alt: 'Modern Twist' },
    { src: 'https://i.ibb.co/0ppHBQrW/Products-19.jpg', alt: 'Gourmet Selection' },
    { src: 'https://i.ibb.co/gMrBFKXc/Products-20.jpg', alt: 'Chef Special' },
    { src: 'https://i.ibb.co/YF0VzhkM/Products-21.jpg', alt: 'Seasonal Favorite' },
    { src: 'https://i.ibb.co/V06tzJLV/Products-22.jpg', alt: 'Customer Choice' },
    { src: 'https://i.ibb.co/LhJSzv1X/Products-23.jpg', alt: 'Best Seller' },
    { src: 'https://i.ibb.co/8Dhkry3z/Products-24.jpg', alt: 'Premium Quality' },
    { src: 'https://i.ibb.co/39mtYfsL/Products-25.jpg', alt: 'Handcrafted' },
    { src: 'https://i.ibb.co/7dHD8cjV/Products-26.jpg', alt: 'Fresh Daily' },
    { src: 'https://i.ibb.co/B2KR2bf4/Products-27.jpg', alt: 'Signature Blend' },
    { src: 'https://i.ibb.co/k2Y9b4LZ/Products-28.jpg', alt: 'Perfect Texture' },
    { src: 'https://i.ibb.co/SwBBm4Bh/Products-29.jpg', alt: 'Golden Crispy' },
    { src: 'https://i.ibb.co/pjz0n9C8/Products-30.jpg', alt: 'Ultimate Indulgence' }
  ];

  return (
    <>
      <Helmet>
        <title>Gallery - Zalabya | Photos of Our Delicious Desserts</title>
        <meta name="description" content="Browse our gallery of mouthwatering Egyptian desserts. See photos of our famous zalabya, Dubai chocolate, strawberry cups and more at Zalabya Mississauga." />
      </Helmet>

      <div className="pt-24 pb-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl font-bold text-gradient mb-4">Gallery</h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Feast your eyes on our delicious creations before you taste them
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.05 }}
                className="relative group cursor-pointer overflow-hidden rounded-lg"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <p className="text-white font-medium text-center px-4">{image.alt}</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Restaurant Photos */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mt-16"
          >
            <h2 className="text-3xl font-bold text-gradient text-center mb-8">Our Restaurant</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { src: 'https://i.ibb.co/VWzv99wv/Shop-Outside.jpg', alt: 'Shop Exterior' },
                { src: 'https://i.ibb.co/K3Wr4DZ/Shop-Outside-1.jpg', alt: 'Restaurant Front' },
                { src: 'https://i.ibb.co/0y0WmmwB/Inside.jpg', alt: 'Interior View' }
              ].map((image, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="relative group cursor-pointer overflow-hidden rounded-lg"
                  onClick={() => setSelectedImage(image)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <p className="text-white font-medium text-center px-4">{image.alt}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              className="relative max-w-4xl max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 text-white text-2xl z-10 bg-black/50 rounded-full p-2 hover:bg-black/70 transition-colors"
              >
                <SafeIcon icon={FiX} />
              </button>
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <div className="absolute bottom-4 left-4 right-4 text-center">
                <p className="text-white text-lg font-medium bg-black/50 rounded-lg px-4 py-2">
                  {selectedImage.alt}
                </p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Gallery;